import { render } from "./role-details.vue?vue&type=template&id=ddb45aa4"
import script from "./role-details.vue?vue&type=script&lang=js"
export * from "./role-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__